export default "__VITE_ASSET__9In5qPic__"